// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-rollup-content {
  height: 0;
}
.fi-rollup-content:not(.notransition) {
  transition: all 0.3s;
}
.fi-rollup-content:not(.roll-up-content-visible) {
  overflow: hidden;
}
.fi-rollup-content.roll-up-content-visible {
  height: auto;
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/rollup/rollup-content.scss"],"names":[],"mappings":"AAAA;EAKI,SAAA;AAHJ;AADI;EACI,oBAAA;AAGR;AAEI;EACI,gBAAA;AAAR;AAGI;EACI,YAAA;AADR","sourcesContent":[".fi-rollup-content {\r\n    &:not(.notransition) {\r\n        transition: all 0.3s;\r\n    }\r\n\r\n    height: 0;\r\n\r\n    &:not(.roll-up-content-visible) {\r\n        overflow: hidden;\r\n    }\r\n\r\n    &.roll-up-content-visible {\r\n        height: auto;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
